import Listbox from 'primevue/listbox'
import WvInfo from './wv-info.vue'
import WvDocs from './wv-docs.vue'

import {Rest} from 'utils'
import {API_ADMIN_WEAVIATE} from 'consts/api'

const __default__ = {
  data() {
    return {
      rest: new Rest(),
      collections: undefined,
      meta: undefined,
      selection: undefined,
      active: 'documents',
      tabs: [
        {value: 'documents', title: 'Documents'}, 
        {value: 'info', title: 'Info'}
      ]
    }
  },
  async mounted() {
    this.meta = await this.rest.get(`${API_ADMIN_WEAVIATE}`)
    this.collections = await this.rest.get(`${API_ADMIN_WEAVIATE}/collections`)
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'weaviate',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { get Rest() { return Rest }, get API_ADMIN_WEAVIATE() { return API_ADMIN_WEAVIATE }, get Listbox() { return Listbox }, WvInfo, WvDocs }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})